<template>
  <div class="block">
    <div class="block-title">抖店兑换券</div>

    <el-tabs v-model="tabIndex" @tab-click="handleTabChange">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.name"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>
    <dd-coupon-synchronization v-if="tabIndex === '1'"/>
    <dd-coupon-use-info v-if="tabIndex === '2'"/>
    <dd-cinema-management v-if="tabIndex === '3'"/>
    <couponsTemplateList v-if="tabIndex === '4'" couponPlatformType="40"></couponsTemplateList>
  </div>
</template>

<script>
import mini from "@/api/mini";
import InterceptStatus from "../groupOrder/InterceptStatus";
import PushTicket from "../groupOrder/PushTicket";
import OrderDetail from "../groupOrder/OrderDetail";
import DdCouponSynchronization from "./ddCouponSynchronization/index.vue";
import DdCouponUseInfo from "./ddCouponUseInfo/index.vue";
import DdCinemaManagement from "./ddCinemaManagement/index.vue";
import couponsTemplateList from "@/components/couponsTemplateList.vue";

const MiniModel = new mini();
const searchParams = {
  orderId: "", // 订单号
  id: "", // 用户ID
  reservedPhone: "", // 手机号
  interceptOrderStatus: "", // 拦截状态
  promoteCode: "", // 推广位名称
  orderCreateTime: [], // 默认时间选择框下单时间为7天
  orderType: 1, // 下单订单类型
  orderCreateStartTime: "",
  orderCreateEndTime: "",
  couponTypeId: '', //是否优惠券下单
};
export default {
  components: {
    DdCinemaManagement,
    DdCouponUseInfo,
    DdCouponSynchronization,
    InterceptStatus,
    OrderDetail,
    PushTicket,
    couponsTemplateList,
  },
  data() {
    return {
      tabList: [
        {
          name: "抖店商品券同步",
          value: "1",
        },
        {
          name: "抖店券使用情况",
          value: "2",
        },
        {
          name: '券模板创建',
          value: "4"
        }
        // {
        //   name: "抖店影院管理",
        //   value: "3",
        // },
      ],
      tabIndex: "1", // 订单状态
    };
  },
  mounted() {

  },
  methods: {
    handleTabChange(tab) {
      this.tabIndex = tab.name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ddCouponExchangeNew/index.vue